export default __webpack_public_path__ + "static/media/SHOPPING_TIME_NETWORK.6986375a.png";